module.exports = __webpack_public_path__ + "static/fonts/calibril.ca17c1d0.ttf";